module.exports = __webpack_public_path__ + "static/media/add-icon.543946f2.svg";